export default __webpack_public_path__ + "static/media/mauritius_brown.609dfe46.png";